import { useQuery } from "@tanstack/react-query";
import { queryOrganizerVenues } from "supabase/venues";
import { Database } from "types/supabase";

export const useQueryOrganizerVenues = (organizerId: number | undefined) => {
  return useQuery<Database["public"]["Tables"]["venues"]["Row"][]>({
    queryKey: ["organizer-venues", organizerId],
    queryFn: () => queryOrganizerVenues(organizerId),
    enabled: organizerId !== undefined,
  });
};
